export default [
	//中医特色老年康养虚拟实践系统
	{
		path: 'cmo',
		component: () => import('../../sys/softwareManage/cmo/index'),
	},
	//神经系统临床思维支持系统
	{
		path: 'nct',
		component: () => import('../../sys/softwareManage/nct/index'),
	},
	// 养老院运营与管理
	{
		path: 'oph',
		component: () => import('../../sys/softwareManage/oph/index'),
	},
	{
		path: 'ophAnalysis',
		component: () => import('../../sys/softwareManage/oph/home'),
	},
	//交互式课件管理
	{
		path: 'jhskj',
		component: () => import('../../sys/softwareManage/jhskj/index'),
	},
	//虚拟养老院
	{
		path: 'vnh',
		component: () => import('../../sys/softwareManage/vnh/index')
	}, {
		path: 'vnhAnalysis',
		component: () => import('../../sys/softwareManage/vnh/home')
	},
	//虚拟养老院-新版
	{
		path: 'virtualNH',
		component: () => import('../../sys/softwareManage/virtualNH/index.vue'),
		children: [{
			path: 'jobPost',
			component: () => import('../../sys/softwareManage/virtualNH/jobPost/index')
		}, {
			path: 'jobPostResource',
			component: () => import('../../sys/softwareManage/virtualNH/jobPostResource/index')
		}, {
			path: 'task',
			component: () => import('../../sys/softwareManage/virtualNH/task/index')
		}, {
			path: 'equipment',
			component: () => import('../../sys/softwareManage/virtualNH/equipment/index')
		}]
	},
	{
		path: 'virtualNHAnalysis',
		component: () => import('../../sys/softwareManage/virtualNH/analysis')
	},
	//老年人能力评估
	{
		path: 'examAssessment',
		component: () => import('../../sys/softwareManage/nna/lnrnlpg'),
	},
	{
		path: 'lnrnlpgAnalysis',
		component: () => import('../../sys/softwareManage/nna/lnrnlpgAnalysis'),
	},
	{
		path: 'lnrnlpg',
		component: () => import('../../sys/softwareManage/nna/lnrnlpg'),
	},
	//护理需求评估
	// {
	// 	path: 'hlxqpg',
	// 	component: () => import('../../sys/softwareManage/nna/hlxqpg'),
	// },
	// {
	// 	path: 'hlxqpgAnalysis',
	// 	component: () => import('../../sys/softwareManage/nna/hlxqpgAnalysis'),
	// },
	//赛训过程评价管理
	{
		path: 'sxpj',
		component: () => import('../../sys/softwareManage/sxpj/index'),
	},
	{
		path: 'sxpjAnalysis',
		component: () => import('../../sys/softwareManage/sxpj/analysis/index'),
	},
	//居家养老住宅适老化创设
	{
		path: 'homeDesign',
		component: () => import('../../sys/softwareManage/homeDesign/index')
	},
	{
		path: 'homeDesignAnalysis',
		component: () => import('../../sys/softwareManage/homeDesign/design/index')
	},
	//辅具认知管理
	{
		path: 'AssistiveDevice_AdsManage',
		component: () => import('../../sys/softwareManage/AssistiveDevice/AdsManage/index')
	},
	//辅具应用管理
	{
		path: 'AssistiveDevice_apply',
		component: () => import('../../sys/softwareManage/AssistiveDevice/apply/index')
	},
	//技能大赛赛项思维训练
	{
		path: 'ecctt',
		component: () => import('../../sys/softwareManage/ecctt/'),
		children: [{
			path: 'zhuanjia',
			component: () => import('../../sys/softwareManage/ecctt/zhuanjia/index')
		}, {
			path: 'pinggu',
			component: () => import('../../sys/softwareManage/ecctt/pinggu/index')
		},
		{
			path: 'sai',
			component: () => import('../../sys/softwareManage/ecctt/sai/index')
		}, {
			path: 'yu',
			component: () => import('../../sys/softwareManage/ecctt/yu/index')
		}, {
			path: 'xun',
			component: () => import('../../sys/softwareManage/ecctt/xun/index')
		}, {
			path: 'zjsj',
			component: () => import('../../sys/softwareManage/ecctt/zjsj/index')
		}, {
			path: 'qm',
			component: () => import('../../sys/softwareManage/ecctt/qm/index')
		}
		]
	},
	{
		path: 'eccttAnalysis',
		component: () => import('../../sys/softwareManage/ecctt/Analysis')
	},
	//老年常见病照护实训系统
	{
		path: 'lncjbzhxt',
		component: () => import('../../sys/softwareManage/lncjbzhxt/index')
	},
	{
		path: 'hospiceCare',
		component: () => import('../../sys/softwareManage/hospiceCare/index')
	},
	{
		path: 'hospiceCareAnalysis',
		component: () => import('../../sys/softwareManage/hospiceCare/home')
	},
	//VR认知症早期筛查与干预训练系统
	{
		path: 'oaka',
		component: () => import('../../sys/softwareManage/oaka/home')
	},
	{
		path: 'oakaAnalysis',
		component: () => import('../../sys/softwareManage/oaka/index')
	},
	//软件参数设置
	{
		path: 'oldAge',
		component: () => import('../../sys/softwareManage/oldAge/index.vue')
	},
	{
		path: 'timeAIDialogue',
		component: () => import('../../sys/softwareManage/timeAIDialogue/userManage.vue')
	},
	{
		path: 'timeAIAnalysis',
		component: () => import('../../sys/softwareManage/timeAIDialogue/index.vue')
	},
	{
		path: 'AIDigitalHuman',
		component: () => import('../../sys/softwareManage/AIDigitalHuman/index.vue'),
		children: [{
			path: 'defaultSetting',
			component: () => import('../../sys/softwareManage/AIDigitalHuman/defaultSetting/index')
		}, {
			path: 'bank',
			component: () => import('../../sys/softwareManage/AIDigitalHuman/bank/index')
		}, {
			path: 'teachingaids',
			component: () => import('../../sys/softwareManage/AIDigitalHuman/teachingaids/index')
		}, {
			path: 'professionallibrary',
			component: () => import('../../sys/softwareManage/AIDigitalHuman/professionallibrary/index')
		}, {
			path: 'consultation',
			component: () => import('../../sys/softwareManage/AIDigitalHuman/consultation/index')
		}, {
			path: 'tcmHealth',
			component: () => import('../../sys/softwareManage/AIDigitalHuman/tcmHealth/index')
		}]
	},
	{
		path: 'AIDigitalHumanAnalysis',
		component: () => import('../../sys/softwareManage/AIDigitalHuman/analysis')
	},
	{
		path: 'basicAssessment',
		component: () => import('../../sys/softwareManage/nlpg/index.vue'),
		redirect: '/sys/basicAssessment/tableManage',
		children: [{
			path: 'tableManage',
			component: () => import('../../sys/softwareManage/nlpg/tableManage/index')
		}, {
			path: 'archivesManage',
			component: () => import('../../sys/softwareManage/nlpg/archivesManage/index')
		}]
	},
	{
		path: 'nlpg3D',
		component: () => import('../../sys/softwareManage/nlpg3D/index.vue'),
		children: [{
			path: 'tablelibrary',
			component: () => import('../../sys/softwareManage/nlpg3D/tablelibrary/index')
		}, {
			path: 'caselibrary',
			component: () => import('../../sys/softwareManage/nlpg3D/caselibrary/index')
		}]
	},
	{
		path: 'elderlyRehabilitation',
		component: () => import('../../sys/softwareManage/elderlyRehabilitation/index.vue')
	},
	{
		path: 'zykangfu',
		component: () => import('../../sys/softwareManage/zykangfu/index.vue')
	},
	{
		path: 'fco',
		component: () => import('../../sys/softwareManage/fco/index.vue')
	}, {
		path: 'fcoAnalysis',
		component: () => import('../../sys/softwareManage/fco/home.vue')
	},
	//资源库-集合
	{
		path: 'miniLib',
		component: () => import('../../sys/resource-center/miniLib/index'),
	},
	{
		path: 'libad',
		component: () => import('../../sys/resource-center/libad/index')
	},
	{
		path: 'libadAnalysis',
		component: () => import('../../sys/resource-center/libad/userlogs')
	},
	{
		path: 'libPanorama',
		component: () => import('../../sys/resource-center/libPanorama/index')
	}, {
		path: 'kbdoc',
		component: () => import('../../sys/resource-center/kbdoc/index')
	},
	//本地知识库（文档/素材向量化检索）
	{
		path: 'localKnowledge',
		component: () => import('../../sys/resource-center/localKnowledge/index')
	}, {
		path: 'agedCaseLib',
		component: () => import('../../sys/resource-center/agedCaseLib/index')
	}, {
		path: 'artiTrainingroom',
		component: () => import('../../sys/softwareManage/arti/index.vue')
	},
	//辅具认知记录
	{
		path: 'adsAnalysis',
		component: () => import('../../sys/analysis/adsAnalysis.vue')
	}, {
		path: 'artiAnalysis',
		component: () => import('../../sys/analysis/artiAnalysis.vue')
	}
]